<template>
  <el-dialog
    width="300px"
    title="Удалить рейс из отчета?"
    top="300px"
    destroy-on-close
    :visible.sync="visible"
    :close-on-click-modal="true"
    :before-close="() => $emit('close')"
  >
    <div class="delete-response-in-report-row">
      <el-button :loading="loading" @click="$emit('close')"> Отмена </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="deleteResponseInReport"
      >
        Удалить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

const TotalReportAPI = RepositoryFactory.get('totalReport')

export default {
  name: 'Delete',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    response: {
      type: Object,
      default: () => {},
    },
    reportId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async deleteResponseInReport() {
      this.loading = true
      await TotalReportAPI.deleteResponse(this.reportId, this.response.id)
        .then(() => this.$emit('update', this.response.id))
        .catch(e => console.log(e))
        .finally(() => {
          this.$emit('close')
          this.loading = false
        })
    },
  },
}
</script>

<style lang="sass">
.delete-response-in-report-row
  display: flex
  justify-content: space-between
  margin-top: 20px
  & > button
    width: 125px
</style>
